import { render, staticRenderFns } from "./MainOrder.vue?vue&type=template&id=ec51fc68&scoped=true"
import script from "./MainOrder.vue?vue&type=script&lang=ts"
export * from "./MainOrder.vue?vue&type=script&lang=ts"
import style0 from "./MainOrder.vue?vue&type=style&index=0&id=ec51fc68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec51fc68",
  null
  
)

export default component.exports